export default {
    url: '/general',
    template: `
        <courses-courses-edit-occurrence-add-general
            occurrence="vm.occurrence"
            can-manage-occurrences="vm.$scope.$parent.vm.canManageOccurrences"
            course="vm.course"
            sites="vm.sites"
            course-versions="vm.courseVersions"
            direct-managers="vm.directManagers"
        />
    `,
    resolve: {
        occurrence (OCCURRENCE_STATUS_ENUM, OccurrenceResource, $stateParams) {
            if ($stateParams.occurrenceId) {
                return OccurrenceResource.get({ id: $stateParams.occurrenceId,
                    expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,sites' }).$promise;
            }
            return new OccurrenceResource({
                courseId: $stateParams.id,
                status: OCCURRENCE_STATUS_ENUM.KEYS.UNPUBLISHED
            });
        },
        sites (SiteResource) {
            return SiteResource.query({ occurrenceOrApgManageSites: true, pageSize: 0 }).$promise;
        },
        courseVersions (CourseVersionResource, $stateParams) {
            return CourseVersionResource.query({ courseId: $stateParams.id, pageSize: 0 }).$promise;
        },
        directManagers (UserManagerService, ROLE_PRIVILEGE_ENUM) {
            return UserManagerService.queryDirectManagersByPrivileges(
                [
                    ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE,
                    ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE,
                    ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE
                ],
                {
                    expand: 'sites,userAssignments',
                    excludeInActiveUsers: true
                }
            );
        }
    },
    controller ($scope, occurrence, course, sites, courseVersions, directManagers, OccurrenceService) {
        this.$scope = $scope;
        $scope.$parent.vm.step = 1;
        $scope.$parent.vm.occurrence = occurrence;
        $scope.$parent.vm.canManageOccurrences = !OccurrenceService.isReadonlyOccurrence(occurrence);
        this.occurrence = occurrence;
        this.course = course;
        this.sites = sites;
        this.courseVersions = courseVersions;
        this.directManagers = directManagers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/add/general/index.js